var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53.5,
    r: 53.5,
    fill: "#32ACDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9411 27.4617L79.2704 41.3258C80.0241 41.8157 80.401 42.0606 80.674 42.3874C80.9157 42.6766 81.0972 43.0111 81.208 43.3714C81.3332 43.7784 81.3332 44.2278 81.3332 45.1268V65.8999C81.3332 70.6604 81.3332 73.0406 80.4067 74.8588C79.5918 76.4582 78.2915 77.7585 76.6921 78.5735C74.8738 79.4999 72.4936 79.4999 67.7332 79.4999H38.2665C33.5061 79.4999 31.1258 79.4999 29.3076 78.5735C27.7082 77.7585 26.4079 76.4582 25.5929 74.8588C24.6665 73.0406 24.6665 70.6604 24.6665 65.8999V45.1268C24.6665 44.2278 24.6665 43.7784 24.7917 43.3714C24.9024 43.0111 25.084 42.6766 25.3257 42.3874C25.5987 42.0606 25.9755 41.8157 26.7292 41.3258L48.0586 27.4617M57.9411 27.4617C56.1525 26.2992 55.2583 25.7179 54.2947 25.4917C53.443 25.2918 52.5566 25.2918 51.7049 25.4917C50.7414 25.7179 49.8471 26.2992 48.0586 27.4617M57.9411 27.4617L75.4856 38.8656C77.4345 40.1324 78.4089 40.7658 78.7464 41.569C79.0413 42.271 79.0413 43.0621 78.7464 43.7641C78.4089 44.5673 77.4345 45.2007 75.4856 46.4675L57.9411 57.8714C56.1526 59.034 55.2583 59.6153 54.2947 59.8414C53.443 60.0413 52.5566 60.0413 51.7049 59.8414C50.7414 59.6153 49.8471 59.034 48.0586 57.8714L30.5141 46.4675C28.5652 45.2007 27.5908 44.5673 27.2533 43.7641C26.9583 43.0621 26.9583 42.271 27.2533 41.569C27.5908 40.7658 28.5652 40.1324 30.5141 38.8656L48.0586 27.4617M79.9165 73.8332L61.0952 56.8332M44.9045 56.8332L26.0832 73.8332",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4a3989347a332429526a82a66d8f6047.svg";
export { ForwardRef as ReactComponent };